<template>
    <button type="button" class="relative flex aspect-[320/52] items-center justify-center">
        <img :src="frame" alt="" class="absolute inset-0 h-full w-full" />
        <span class="font-title relative pt-[1%] text-xs font-bold text-white uppercase">
            <slot />
        </span>
    </button>
</template>

<script>
import frame from '@/assets/images/games/killer/splash/button.svg'

export default {
    name: 'KillerMenuButton',
    data() {
        return {
            frame,
        }
    },
}
</script>
